import styled from '@emotion/styled'
import {InputPicker} from 'rsuite'

export const SInputPicker = styled(InputPicker)`
  width: 100%;
`
